import { render, staticRenderFns } from "./demo3.vue?vue&type=template&id=0325bbec&scoped=true"
import script from "./demo3.vue?vue&type=script&lang=js"
export * from "./demo3.vue?vue&type=script&lang=js"
import style0 from "./demo3.vue?vue&type=style&index=0&id=0325bbec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0325bbec",
  null
  
)

export default component.exports